import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { baseUrl } from "../Utility/constants";

const useSchoolData = () => {
    const [schoolInfo, setSchoolInfo] = useState(null);
    const [schoolContactInfo, setSchoolContactInfo] = useState(null);
    const [schoolId, setSchoolId] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadSchoolData = async () => {
            try {
                // First API
                const schoolResponse = await axios.get(
                    `${baseUrl}/api/SchoolGeneralInfo`
                );

                const school = schoolResponse.data?.[0];

                setSchoolInfo(school);
                setSchoolId(school?.schoolId);

                // Second API
                const contactResponse = await axios.get(
                    `${baseUrl}/api/ContactAffiliationInfo/GetschoolContactDetailsBySchoolId?schoolId=${school.schoolId}`
                );

                setSchoolContactInfo(contactResponse.data);
            }
            catch (error) {
                console.error(error);
                //toast.error("Failed to load school information.");
            }
            finally {
                setLoading(false);
            }
        };

        loadSchoolData();
    }, []);

    return {
        schoolInfo,
        schoolContactInfo,
        schoolId,
        loading
    };
};

export default useSchoolData;